import {useRoute, useRouter} from "vue-router";
import apiUtil from "@/apiUtil";
import {computed, ref} from "vue";
import setTitle from "@/utils/setTitle";
import {Notify} from "vant";

export default function (onGet?: () => void) {
  let route = useRoute();
  let agreementContent = ref(null);
  let edition = computed(() => route.query.edition ? route.query.edition : null)

  /**
   * 获取协议
   */
  async function getAgreement() {
    let res = await apiUtil.apiUtilGetUrl('/PKECUser/article/getArticleContent?articleId='+route.query.articleId);
    if(res.errorMessage){
      Notify({type: 'danger', message: res.errorMessage});
    }else {
      agreementContent.value = res.content
      setTitle( res.title)
    }
  }

  (async () => {
    await getAgreement();
    onGet?.();
  })();


  return {
    edition,
    agreementContent
  }
}
